import React from 'react';
import { Phone, Mail, MapPin, Facebook } from 'lucide-react';
import { businessInfo } from '../mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-white text-2xl font-bold mb-4">All-Out Moving</h3>
            <p className="mb-4 text-gray-400">
              Professional moving and junk removal services serving Manitowoc and surrounding areas since 2019.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <span className="font-semibold text-orange-500">DOT# 3310412</span>
              <span>|</span>
              <span>Licensed & Insured</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { name: 'Home', id: 'home' },
                { name: 'Services', id: 'services' },
                { name: 'About Us', id: 'about' },
                { name: 'Testimonials', id: 'testimonials' },
                { name: 'FAQ', id: 'faq' },
                { name: 'Contact', id: 'contact' }
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="hover:text-orange-500 transition-colors"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li className="hover:text-orange-500 transition-colors">Professional Moving</li>
              <li className="hover:text-orange-500 transition-colors">Junk Removal</li>
              <li className="hover:text-orange-500 transition-colors">Small Demolition</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li>
                <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-2 hover:text-orange-500 transition-colors">
                  <Phone size={18} />
                  <span>{businessInfo.phone}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${businessInfo.email}`} className="flex items-center gap-2 hover:text-orange-500 transition-colors break-all">
                  <Mail size={18} />
                  <span>{businessInfo.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={18} className="flex-shrink-0 mt-1" />
                <span>{businessInfo.address}</span>
              </li>
              <li>
                <a 
                  href="https://www.facebook.com/AllOutMoving98/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 hover:text-orange-500 transition-colors"
                >
                  <Facebook size={18} />
                  <span>Follow us on Facebook</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>
              © {currentYear} All-Out Moving and Junk Removal. All rights reserved.
            </p>
            <p>
              Serving Manitowoc, Two Rivers, Sheboygan, Green Bay & Surrounding Areas
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
